<!--

  @copyright Copyright (c) Open-Xchange GmbH, Germany <info@open-xchange.com>
  @license AGPL-3.0

  This code is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with OX App Suite. If not, see <https://www.gnu.org/licenses/agpl-3.0.txt>.

  Any use of the work other than as authorized under this license or copyright law is prohibited.

-->

<template>
  <BaseButton
    type="button"
    :aria-label="props.ariaLabel"
  >
    <span v-if="props.title" aria-hidden="true" :title="props.title">
      <BaseIcon :icon-name="icon" :class="props.iconClass" />
    </span>
    <BaseIcon v-else :icon-name="icon" :name="props.iconClass" :class="props.iconClass" />
  </BaseButton>
</template>

<script setup>
import BaseButton from '@/io.ox/vueComponents/base-button.vue'
import BaseIcon from '@/io.ox/vueComponents/base-icon.vue'
const props = defineProps({
  icon: {
    type: String,
    default: ''
  },
  iconClass: {
    type: String,
    default: ''
  },
  ariaLabel: {
    type: String,
    default: null
  },
  title: {
    type: String,
    default: undefined
  }
})
</script>
